var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80895 8.92386C7.66222 8.92471 7.51677 8.89659 7.38093 8.8411C7.24509 8.78562 7.12154 8.70387 7.01736 8.60054L0.327887 1.91106C0.117944 1.70112 0 1.41638 0 1.11947C0 0.822572 0.117944 0.537829 0.327887 0.327887C0.537829 0.117944 0.822572 0 1.11947 0C1.41638 0 1.70112 0.117944 1.91106 0.327887L7.80895 6.23692L13.7068 0.339036C13.9201 0.156384 14.1945 0.06094 14.4751 0.0717783C14.7557 0.0826165 15.0218 0.198939 15.2204 0.397498C15.419 0.596058 15.5353 0.862231 15.5461 1.14283C15.557 1.42343 15.4615 1.69778 15.2789 1.91106L8.58939 8.60054C8.38173 8.80651 8.10144 8.92263 7.80895 8.92386Z",
    fill: "#242A31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3198bde3295dcb088171341897de2c0a.svg";
export { ForwardRef as ReactComponent };